"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.map");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  columns: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    key: _propTypes["default"].string.isRequired,
    title: _propTypes["default"].string
  }))
};
var defaultProps = {
  columns: []
};

var TableHead = function TableHead(_ref) {
  var columns = _ref.columns;
  return /*#__PURE__*/_react["default"].createElement("thead", {
    className: "grv-table__head"
  }, /*#__PURE__*/_react["default"].createElement("tr", {
    className: "grv-table__row"
  }, columns.map(function (column) {
    return /*#__PURE__*/_react["default"].createElement("th", {
      className: "grv-table__header",
      key: column.key,
      scope: "col"
    }, column.title);
  })));
};

TableHead.propTypes = propTypes;
TableHead.defaultProps = defaultProps;
var _default = TableHead;
exports["default"] = _default;